import React from 'react';

import CatalogShell from './CatalogShell';

/**
 * Cohort attribute definitions — the typed attribute keys cohort rule
 * JSON is allowed to predicate on. `data_type` drives coercion; the
 * free-form `value_source` documents where the live value originates
 * (e.g. `member`, `consumer`, `derived`).
 */
const CohortAttributeDefs: React.FC = () => (
  <CatalogShell
    slug="cohort-attribute-defs"
    title="Cohort attribute definitions"
    breadcrumbLabel="Cohort attributes"
    emptyBody="Cohort attribute definitions are the typed registry of keys that cohort rule JSON may filter on."
    addCtaLabel="Add first cohort attribute"
    extraColumns={[
      {
        name: 'data_type',
        label: 'Data type',
        type: 'select',
        options: ['STRING', 'INTEGER', 'DECIMAL', 'BOOLEAN', 'DATE', 'TIMESTAMP', 'JSON'],
        width: 140,
      },
      {
        name: 'value_source',
        label: 'Value source',
        type: 'text',
        width: 160,
      },
    ]}
  />
);

export default CohortAttributeDefs;
